"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearItemsInStorage = exports.setKeyInStorage = exports.hasKeyInStorage = exports.getKeyInStorage = void 0;
const store_1 = __importDefault(require("./store"));
const lodash_1 = require("lodash");
exports.getKeyInStorage = (key) => {
    try {
        return store_1.default.get(key);
    }
    catch (e) {
        return undefined;
    }
};
exports.hasKeyInStorage = (key) => {
    const storageKey = exports.getKeyInStorage(key);
    return !lodash_1.isNil(storageKey);
};
exports.setKeyInStorage = (key, value) => {
    try {
        return store_1.default.set(key, value);
    }
    catch (e) {
        return undefined;
    }
};
exports.clearItemsInStorage = store_1.default.clear;
